import {
  ActionType,
  DropFromLaidToHomePayload,
  DropFromLaidToLaidPayload,
  DropFromSlotsToHomePayload,
  DropFromSlotsToSlotsPayload,
  IChangeScores,
  IChangeVolume,
  IDropFromLaidToHomeAction,
  IDropFromLaidToLaidAction,
  IDropFromLaidToSlotsAction,
  IDropFromSlotsToHomeAction,
  IDropFromSlotsToLaidAction,
  IDropFromSlotsToSlotsAction,
  IncreaseHintNumber,
  INewGame,
  IRestartGame,
  ISetOrientation,
  IShowCardsOverflowMessage,
  IToggleModal,
  LaidSlotsDropPayload,
} from './types';
import { Orientation } from '../utils/detectOrientation';

export function dropFromLaidToLaid(payload: DropFromLaidToLaidPayload): IDropFromLaidToLaidAction {
  return {
    type: ActionType.DropFromLaidToLaid,
    payload,
  };
}

export function dropFromLaidToSlots(payload: LaidSlotsDropPayload): IDropFromLaidToSlotsAction {
  return {
    type: ActionType.DropFromLaidToSlots,
    payload,
  };
}

export function dropFromSlotsToLaid(payload: LaidSlotsDropPayload): IDropFromSlotsToLaidAction {
  return {
    type: ActionType.DropFromSlotsToLaid,
    payload,
  };
}

export function dropFromSlotsToSlots(payload: DropFromSlotsToSlotsPayload): IDropFromSlotsToSlotsAction {
  return {
    type: ActionType.DropFromSlotsToSlots,
    payload,
  };
}

export function dropFromLaidToHome(payload: DropFromLaidToHomePayload): IDropFromLaidToHomeAction {
  return {
    type: ActionType.DropFromLaidToHome,
    payload,
  };
}

export function dropFromSlotsToHome(payload: DropFromSlotsToHomePayload): IDropFromSlotsToHomeAction {
  return {
    type: ActionType.DropFromSlotsToHome,
    payload,
  };
}

export function setListening(listening: boolean) {
  return {
    type: ActionType.SetListening,
    payload: {
      listening,
    },
  };
}

export function undo() {
  return {
    type: ActionType.Undo,
  };
}

export function toggleModal(name: string): IToggleModal {
  return {
    type: ActionType.ToggleModal,
    payload: {
      name,
    },
  };
}

export function newGame(): INewGame {
  return {
    type: ActionType.NewGame,
  };
}

export function restartGame(): IRestartGame {
  return {
    type: ActionType.RestartGame,
  };
}

export function showCardsOverflowMessage(
  visible: boolean,
  maxCards: number,
  needCards: number
): IShowCardsOverflowMessage {
  return {
    type: ActionType.ShowCardsOverflowMessage,
    payload: {
      visible: Boolean(visible),
      maxCards,
      needCards,
    },
  };
}

export function increaseHintNumber(): IncreaseHintNumber {
  return {
    type: ActionType.IncreaseHintNumber,
  };
}

export function setOrientation(orientation: Orientation, contentWidth: number): ISetOrientation {
  return {
    type: ActionType.SetOrientation,
    payload: {
      orientation,
      contentWidth,
    },
  };
}

export function changeScores(scores: number): IChangeScores {
  return {
    type: ActionType.ChangeScores,
    payload: {
      scores,
    },
  };
}

export function changeVolume(): IChangeVolume {
  return {
    type: ActionType.ChangeVolume,
  };
}
